// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__jLweq","genericError":"Form_genericError__nYxNN","email":"Form_email__jE2Cb","autoLoginCheckBox":"Form_autoLoginCheckBox__H0K3e"};